import React from 'react';

import { Nullable } from '@clearverify/types';

import {
  PeoPayrollProviderStaffDocument,
  PeoPayrollProviderStaffRole,
  PeoPayrollProviderStaffUpdate,
  usePeoPayrollProviderStaffQuery,
  usePeoPayrollProviderStaffUpdateMutation,
} from 'src/api';

export const usePeoPayrollProviderStaff = (peoPayrollProviderStaffId?: Nullable<string>) => {
  const { data, loading } = usePeoPayrollProviderStaffQuery({
    variables: {
      id: peoPayrollProviderStaffId || '',
    },
    skip: !peoPayrollProviderStaffId,
  });

  const [peoPayrollProviderStaffUpdateMutation, { loading: updating }] =
    usePeoPayrollProviderStaffUpdateMutation({
      refetchQueries: [PeoPayrollProviderStaffDocument],
      awaitRefetchQueries: true,
    });

  const peoPayrollProviderStaff = React.useMemo(
    () => data?.peoPayrollProviderStaff,
    [data?.peoPayrollProviderStaff],
  );

  const isPeoPayrollProviderUser = React.useMemo(
    () => peoPayrollProviderStaff?.role === PeoPayrollProviderStaffRole.PeoPayrollProviderUser,
    [peoPayrollProviderStaff?.role],
  );

  const updatePeoPayrollProviderStaff = React.useCallback(
    async (data: PeoPayrollProviderStaffUpdate) => {
      if (!peoPayrollProviderStaffId) {
        return;
      }

      await peoPayrollProviderStaffUpdateMutation({
        variables: {
          where: { id: peoPayrollProviderStaffId },
          data,
        },
      });
    },
    [peoPayrollProviderStaffId, peoPayrollProviderStaffUpdateMutation],
  );

  return {
    peoPayrollProviderStaff,
    isPeoPayrollProviderUser,
    updatePeoPayrollProviderStaff,
    loading,
    updating,
  };
};
